import React, { useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import GlobalSnackbarNotifier from '../views-2/components/ui-widgets/GlobalSnackbarNotifier';
import ExchangeInstructionBatchesPage
  from '../views-2/pages/finance-area/currency-exchange-instructions/ExchangeInstructionBatchesPage'
import ExchangeInstructionBatchPage
  from '../views-2/pages/finance-area/currency-exchange-instructions/ExchangeInstructionBatchPage'
import CreateInstruction
  from '../views-2/pages/finance-area/currency-exchange-instructions/CreateInstruction'
import DisbursementBatchesPage from '../views-2/pages/finance-area/disbursements/DisbursementBatchesPage';
import DisbursementBatchPage from '../views-2/pages/finance-area/disbursements/DisbursementBatchPage';
import SolarMonitoringMetricsPage
  from '../views-2/pages/solar-engineering/monitoring-metrics/SolarMonitoringMetricsPage';
import SolarEngineeringLandingPage from '../views-2/pages/solar-engineering/SolarEngineeringLandingPage';
import CreateSolarProjectPage from '../views-2/pages/solar-projects/CreateSolarProjectPage';
import CurrencyExchangeOrdersPage
  from '../views-2/pages/finance-area/currency-exchange-orders/CurrencyExchangeOrdersPage';
import EditSolarProjectPage from '../views-2/pages/solar-projects/EditSolarProjectPage';
import SolarProjectsPage from '../views-2/pages/solar-projects/SolarProjectsPage';
import FinanceLandingPage from '../views-2/pages/finance-area/FinanceLandingPage';
import CurrencyExchangePairsPage from '../views-2/pages/finance-area/currency-exchange-pairs/CurrencyExchangePairsPage';

import SidebarNavigationComponent from './components/shared/SidebarNavigationComponent';
import DashboardPage from './pages/DashboardPage';
import StatementsPage from './pages/payments/eft-statements/StatementsPage';
import StatementPage from './pages/payments/eft-statements/StatementPage';

import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import OrganisationsPage from './pages/organisations/OrganisationsPage';
import OrganisationPage from './pages/organisations/OrganisationPage';
import CreateOrganisationPage from './pages/organisations/CreateOrganisationPage';

import CustomerOperationsPage from '../views-2/pages/customer-operations/CustomerOperationsPage';
import EditAssetHolderPage from '../views-2/pages/customer-operations/EditAssetHolderPage';
import KycArchiveSearchPage from '../views-2/pages/kyc-archive/KycArchiveSearchPage';
import KycArchiveApplicationPage from '../views-2/pages/kyc-archive/KycArchiveApplicationPage';
import AdhocDistributionsPage from '../views-2/pages/finance-area/adhoc-distributions/AdhocDistributionsPage';
import SolarPlantsPage from '../views-2/pages/solar-engineering/solar-plants/SolarPlantsPage';
import EditSolarPlantPage from '../views-2/pages/solar-engineering/solar-plants/EditSolarPlantPage';
import WeeklyDistributionsPage from '../views-2/pages/finance-area/weekly-distributions/WeeklyDistributionsPage';
import MonthlyBillingRunPage from '../views-2/pages/finance-area/weekly-distributions/MonthlyBillingRunPage';
import DistributionInstructionPage
  from '../views-2/pages/finance-area/weekly-distributions/DistributionInstructionPage';
import EmailNotificationsPage from '../views-2/pages/finance-area/email-notifcations/EmailNotificationsPage';
import CreateEmailNotificationPage from '../views-2/pages/finance-area/email-notifcations/CreateEmailNotificationPage';
import DisbursementFeesPage from '../views-2/pages/finance-area/disbursements/DisbursementFeesPage';
import SettlementsPage from '../views-2/pages/finance-area/settlements/SettlementsPage';
import SettlementPage from '../views-2/pages/finance-area/settlements/SettlementPage';
import SettlementProjectPage from '../views-2/pages/finance-area/settlements/SettlementProjectPage';
import EditOrganisationPage from './pages/organisations/EditOrganisationPage';
import JournalReconPeriodsPage from '../views-2/pages/finance-area/journal-recons/JournalReconPeriodsPage';
import JournalReconPeriodPage from '../views-2/pages/finance-area/journal-recons/JournalReconPeriodPage';
import AccountChargeRunPage from '../views-2/pages/finance-area/account-charges/AccountChargeRunPage';
import AccountChargeExclusionsPage from '../views-2/pages/finance-area/account-charges/AccountChargeExclusionsPage';

const AdminPortal = (props: any) => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const drawerWidth = 300;

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const DrawerHeader = styled('div')(({ theme }: any) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  }));

  interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open'
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    })
  }));

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" open={openDrawer}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: '30px',
              ...(openDrawer && { display: 'none' })
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Sun Exchange Administration
          </Typography>
        </Toolbar>
      </AppBar>

      <SidebarNavigationComponent openDrawer={openDrawer} handleDrawerClose={handleDrawerClose} DrawerHeader={DrawerHeader} />

      <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
        <DrawerHeader />

        <GlobalSnackbarNotifier/>

        {<Redirect exact from={'/app'} to={'/app/dashboard'} />}
        <Route exact={true} path={'/app/dashboard'}>
          <DashboardPage />
        </Route>

        <Route exact path={'/app/customer-operations'}>
          <CustomerOperationsPage />
        </Route>
        <Route exact={true} path={'/app/asset-holder/:assetHolderId'}>
          <EditAssetHolderPage />
        </Route>
        {/*<Route exact={true} path={'/app/asset-holder/free-cells/:assetHolderId'}>*/}
        {/*  <GiftFreeCellsPage />*/}
        {/*</Route>*/}

        <Route exact path={'/app/kyc-archive'}>
          <KycArchiveSearchPage />
        </Route>
        <Route exact path={'/app/kyc-archive/:applicationId'}>
          <KycArchiveApplicationPage />
        </Route>

        <Route exact path={'/app/distributions/run'}>
          <WeeklyDistributionsPage />
        </Route>
        <Route exact path={'/app/distributions/run/:billingRunMonthlyId'}>
          <MonthlyBillingRunPage />
        </Route>
        <Route exact path={'/app/distributions/instruction/:distributionInstructionId'}>
          <DistributionInstructionPage />
        </Route>
        <Route exact path={'/app/adhoc-distributions/pending'}>
          <AdhocDistributionsPage />
        </Route>
        <Route exact path={'/app/distributions/emails'}>
          <EmailNotificationsPage />
        </Route>
        <Route exact path={'/app/distributions/emails/create'}>
          <CreateEmailNotificationPage />
        </Route>

        {/* New project pages */}
        <Route exact path={'/app/projects'}>
          <SolarProjectsPage />
        </Route>
        <Route exact path={'/app/projects/:projectSlug/edit'}>
          <EditSolarProjectPage />
        </Route>
        <Route exact path={'/app/projects/create'}>
          <CreateSolarProjectPage />
        </Route>


        {/* New finance area pages */}
        <Route exact path={'/app/finance-area'}>
          <FinanceLandingPage />
        </Route>
        <Route exact path={'/app/finance-area/currency-exchange-orders'}>
          <CurrencyExchangeOrdersPage />
        </Route>
        <Route exact path={'/app/finance-area/currency-exchange-pairs'}>
          <CurrencyExchangePairsPage />
        </Route>
        <Route exact path={'/app/finance-area/statements'}>
          <StatementsPage />
        </Route>
        <Route exact path={'/app/finance-area/statements/:statementId'}>
          <StatementPage />
        </Route>
        <Route exact path={'/app/finance-area/disbursements/batches'}>
          <DisbursementBatchesPage />
        </Route>
        <Route exact path={'/app/finance-area/disbursements/batches/:disbursementBatchId'}>
          <DisbursementBatchPage />
        </Route>
        <Route exact path={'/app/finance-area/disbursements/fees'}>
          <DisbursementFeesPage />
        </Route>

        <Route exact path={'/app/finance-area/currency-exchange-instructions/create'}>
          <CreateInstruction />
        </Route>
        <Route exact path={'/app/finance-area/currency-exchange-instructions/batches'}>
          <ExchangeInstructionBatchesPage />
        </Route>
        <Route exact path={'/app/finance-area/currency-exchange-instructions/batches/:batchId/edit'}>
          <ExchangeInstructionBatchPage />
        </Route>



        <Route exact path={'/app/finance-area/settlements'}>
          <SettlementsPage />
        </Route>
        <Route exact path={'/app/finance-area/settlements/:portfolioId/edit'}>
          <SettlementPage />
        </Route>
        <Route exact path={'/app/finance-area/settlements/project/:projectSettlementId/edit'}>
          <SettlementProjectPage />
        </Route>

        <Route exact path={'/app/finance-area/journal-recons'}>
          <JournalReconPeriodsPage />
        </Route>
        <Route exact path={'/app/finance-area/journal-recons/:startDate'}>
          <JournalReconPeriodPage />
        </Route>
        <Route exact path={'/app/finance-area/account-charges/run'}>
          <AccountChargeRunPage />
        </Route>
        <Route exact path={'/app/finance-area/account-charges/exclusions'}>
          <AccountChargeExclusionsPage />
        </Route>

        {/* New solar engineering pages */}
        <Route exact path={'/app/solar-engineering-area'}>
          <SolarEngineeringLandingPage />
        </Route>
        <Route exact path={'/app/solar-engineering/solar-plants'}>
          <SolarPlantsPage />
        </Route>
        <Route exact path={'/app/solar-engineering/solar-plants/:solarProjectId/edit'}>
          <EditSolarPlantPage />
        </Route>
        <Route exact path={'/app/solar-engineering/monitoring-metrics'}>
          <SolarMonitoringMetricsPage />
        </Route>



        <Route exact={true} path={'/app/organisations'}>
          <OrganisationsPage />
        </Route>
        <Route exact={true} path={'/app/add-organisation'}>
          <CreateOrganisationPage />
        </Route>
        <Route exact={true} path={'/app/organisations/:organisationId'}>
          <OrganisationPage />
        </Route>
        <Route exact={true} path={'/app/organisations/:organisationId/edit'}>
          <EditOrganisationPage />
        </Route>
      </Box>
    </Box>
  );
};

export default AdminPortal;
